


import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SimpleLoader extends Vue {
  @Prop() loading!: boolean;
  private show = false;
  private timeout!: NodeJS.Timeout;

  private mounted() {
    this.loadingChanged(this.loading);
  }

  @Watch('loading')
  private loadingChanged(to: boolean) {
    if (this.timeout) clearTimeout(this.timeout);

    if (to) {
      this.timeout = setTimeout(() => {
        this.show = this.loading;
      }, 300);
    } else {
      this.show = false;
    }
  }
}
